import { render } from "./WidgetPage.vue?vue&type=template&id=807731ba&scoped=true"
import script from "./WidgetPage.vue?vue&type=script&lang=js"
export * from "./WidgetPage.vue?vue&type=script&lang=js"

import "./WidgetPage.vue?vue&type=style&index=0&id=807731ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-807731ba"]])

export default __exports__